import { render, staticRenderFns } from "./teacher_authorize.vue?vue&type=template&id=3cac3c31&scoped=true"
import script from "./teacher_authorize.vue?vue&type=script&lang=ts"
export * from "./teacher_authorize.vue?vue&type=script&lang=ts"
import style0 from "./teacher_authorize.vue?vue&type=style&index=0&id=3cac3c31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac3c31",
  null
  
)

export default component.exports